<div class="flex flex-column gap-2 h-full">
  <div class="label">
    <span>{{ label }}</span>
  </div>
  <ng-content></ng-content>
</div>
